import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { Const } from '../../../static/const';
import { HttpClient } from '@angular/common/http';

// Replace this with your real mock JSON data
const MOCK_JSON = [
  {
    claim_name: 'CLM-000822',
    statement: 'REMOVES TOUGH STAINS AND 99.9% GERMS IN 1 WASH',
    qualifier: 'Qualifier 1\n\n',
    marketing_channels: [
      'ecommerce__c',
      'concept_claim__c',
      'pack_bop__c',
      'packaging__v',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000001001',
        'substantiation__vr.description__v': 'Test unclassified',
        'substantiation__vr.name__v': 'SUB-000001',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000001002',
        'substantiation__vr.description__v': 'Test CR0403',
        'substantiation__vr.name__v': 'SUB-000002',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000002001',
        'substantiation__vr.description__v': 'Smooth and Silky',
        'substantiation__vr.name__v': 'SUB-000003',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003001',
        'substantiation__vr.description__v': null,
        'substantiation__vr.name__v': 'SUB-000004',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004002',
        'substantiation__vr.description__v': 'test',
        'substantiation__vr.name__v': 'SUB-000006',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003002',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000007',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003003',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000008',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003004',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000009',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003005',
        'substantiation__vr.description__v': 'a',
        'substantiation__vr.name__v': 'SUB-000010',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003006',
        'substantiation__vr.description__v': 'a',
        'substantiation__vr.name__v': 'SUB-000011',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004003',
        'substantiation__vr.description__v': 'test',
        'substantiation__vr.name__v': 'SUB-000012',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004004',
        'substantiation__vr.description__v': 'testing',
        'substantiation__vr.name__v': 'SUB-000013',
        'substantiation__vr.substantiation_details__c': null,
      },
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004005',
        'substantiation__vr.description__v': 'test',
        'substantiation__vr.name__v': 'SUB-000014',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-000823',
    statement: 'Beat dullness, Protect Colours from Fading',
    qualifier: '\n',
    marketing_channels: [
      'ecommerce__c',
      'concept_claim__c',
      'pack_bop__c',
      'packaging__v',
    ],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000828',
    statement: 'Tough Stain Removal in Machine itself',
    qualifier: '\n',
    marketing_channels: ['concept_claim__c', 'ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000824',
    statement: 'Super Soak Technology FOR SUPER STAIN REMOVAL',
    qualifier: '\n',
    marketing_channels: ['concept_claim__c', 'ecommerce__c', 'packaging__v'],
    support_strategy_rich: 'NA',
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000825',
    statement: '100% TOUGH STAIN REMOVAL IN MACHINES',
    qualifier: '\n',
    marketing_channels: ['concept_claim__c', 'ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000T058',
        'substantiation__vr.description__v': 'test substantiation',
        'substantiation__vr.name__v': 'SUB-000216',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-000826',
    statement: 'BUY NOW',
    qualifier: '\n',
    marketing_channels: ['concept_claim__c', 'ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000827',
    statement: '99% Anti Bacterial Action',
    qualifier: '\n',
    marketing_channels: ['concept_claim__c', 'ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000923',
    statement: '1 C G',
    qualifier:
      'Note: This service request may take up to 3 business days & you will be notified up on completion.',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000924',
    statement: 'unilever.sharepoint.com/sites/CollaborationChangeCal',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000926',
    statement: '0 Edit all',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000929',
    statement: 'RFC Number CHG0297779',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000932',
    statement: 'SharePoint Site Address',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000933',
    statement: 'https://unilever.sharepoint.com/sites/VeevaClaimsQ',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000936',
    statement: 'Supporting Team Name',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000938',
    statement:
      'Which team would support the site if functionality related to SharePoint app breaks?',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000941',
    statement:
      'Email Address of team members who is going to support the site in future?',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000943',
    statement:
      'Who is Business contact from Unilever who has requested for the application?',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000009001',
        'substantiation__vr.description__v':
          'This claim will be supported by published results of lab tests that show formation of new mineral within dentine tubules. The results are published in the Journal of Dentistry: In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate - ScienceDirect',
        'substantiation__vr.name__v': 'SUB-000056',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-000944',
    statement: 'Manually added statement',
    qualifier:
      'Note: This service request may take up to 3 business days & you will be notified up on completion.',
    marketing_channels: ['concept_claim__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000925',
    statement: 'SharePoint',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000P005',
        'substantiation__vr.description__v': 'DEV or QA',
        'substantiation__vr.name__v': 'SUB-000126',
        'substantiation__vr.substantiation_details__c':
          'Details about substantiation',
      },
    ],
  },
  {
    claim_name: 'CLM-000927',
    statement: 'Collaborati ... > Generation ... > New',
    qualifier:
      'Note: This service request may take up to 3 business days & you will be notified up on completion.',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000928',
    statement:
      'Note: This service request may take up to 3 business days & you will be notified up on completion.',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000930',
    statement: 'Title',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000931',
    statement: 'New SharePoint ClientID and Secret required',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000934',
    statement: 'Permission Type',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000935',
    statement: 'Full Control',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000003001',
        'substantiation__vr.description__v': null,
        'substantiation__vr.name__v': 'SUB-000004',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-000937',
    statement: 'Unilever Veeva Claims',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000939',
    statement: 'Supporting Team Details',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000940',
    statement: 'Rastogi, Mahima, C01, Madhu, Bhaumik, Subhojit',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000942',
    statement: 'Unilever Business Contact Tawani, Amit',
    qualifier: '\n',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000981',
    statement:
      'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
    qualifier: null,
    marketing_channels: ['concept_claim__c', 'press_releases__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-000979',
    statement:
      'Experience the soothing fragrance of new Bold 2in1 Lavender & Camomile Gel',
    qualifier: 'Bold Qualifier',
    marketing_channels: [
      'concept_claim__c',
      'ecommerce__c',
      'packaging__v',
      'pack_bop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001030',
    statement: 'WITH LONG LASTING FRAGRANCE',
    qualifier: 'Qualifier Test',
    marketing_channels: [
      'ecommerce__c',
      'packaging__v',
      'top__c',
      'tvc_television_commercial__v',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001024',
    statement: '3X TOUGH STAINS',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001040',
    statement: 'Bright like new',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001041',
    statement: 'Keep shining',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001061',
    statement: 'CUIDA DO MEIO AMBIENTE',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001043',
    statement: 'Sample',
    qualifier: 'Sample 12345Qualifier\u00a0',
    marketing_channels: ['concept_claim__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001052',
    statement: 'My Own GB Translation',
    qualifier: 'Test quali</p>',
    marketing_channels: ['packaging__v', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001053',
    statement: 'Biodegradable ingredients',
    qualifier: null,
    marketing_channels: ['concept_claim__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001054',
    statement:
      'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
    qualifier: null,
    marketing_channels: ['concept_claim__c', 'press_releases__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001060',
    statement: 'IMBAT\u00cdVEL NA LIMPEZA',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001062',
    statement: 'CONTEM 800 g LAVA ROUPAS EM P\u00d3',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001066',
    statement: 'This is LA Testing to Save Translations',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001218',
    statement: 'Kitchen Cleaner Benefits',
    qualifier: null,
    marketing_channels: [
      'pack_bop__c',
      'pack_fop__c',
      'packaging__v',
      'tvc_television_commercial__v',
      'top__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001220',
    statement: '100% unbeatable* streak-free shine',
    qualifier: null,
    marketing_channels: [
      'pack_bop__c',
      'ecommerce__c',
      'pack_fop__c',
      'packaging__v',
      'tvc_television_commercial__v',
      'top__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001217',
    statement:
      '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
    qualifier: null,
    marketing_channels: [
      'pack_bop__c',
      'pack_fop__c',
      'top__c',
      'tvc_television_commercial__v',
      'packaging__v',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001219',
    statement: 'Beautifully clean & shiny kichen',
    qualifier: null,
    marketing_channels: [
      'pack_bop__c',
      'ecommerce__c',
      'pack_fop__c',
      'packaging__v',
      'tvc_television_commercial__v',
      'top__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001221',
    statement: '100% oil and grease stain removal',
    qualifier: null,
    marketing_channels: [
      'pack_fop__c',
      'packaging__v',
      'ecommerce__c',
      'website__v',
      'pack_bop__c',
      'tvc_television_commercial__v',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001239',
    statement: 'Test1',
    qualifier: 'Performance Qualifiers',
    marketing_channels: [
      'pack_bop__c',
      'concept_claim__c',
      'packaging__v',
      'ecommerce__c',
      'press_releases__c',
      'social_media__v',
      'pack_fop__c',
      'pos_material__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001254',
    statement: 'CUIDA DO MEIO AMBIENTE',
    qualifier: null,
    marketing_channels: [
      'ecommerce__c',
      'pack_bop__c',
      'packaging__v',
      'pack_fop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001257',
    statement: 'ATIVO CONCENTRADO TECNOLOGIA QUE CUIDA DO MEIO AMBIENTE',
    qualifier: null,
    marketing_channels: [
      'ecommerce__c',
      'pack_bop__c',
      'packaging__v',
      'pack_fop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001363',
    statement: 'Cif POWER & SHINE',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001378',
    statement: '99.9% BACTERIA PROTECTION',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001381',
    statement: 'PLATINUM',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001251',
    statement: 'lavagemperfeita',
    qualifier: null,
    marketing_channels: [
      'ecommerce__c',
      'pack_bop__c',
      'packaging__v',
      'pack_fop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001252',
    statement: 'Imbat\u00edvel na LIMPEZA cuida do meio ambiente 5 UL',
    qualifier: null,
    marketing_channels: [
      'ecommerce__c',
      'pack_bop__c',
      'packaging__v',
      'pack_fop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001253',
    statement: 'IMBAT\u00cdVEL NA LIMPEZA',
    qualifier: null,
    marketing_channels: [
      'ecommerce__c',
      'pack_bop__c',
      'packaging__v',
      'pack_fop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001255',
    statement: 'CONTEM 800 g LAVA ROUPAS EM P\u00d3',
    qualifier: null,
    marketing_channels: [
      'ecommerce__c',
      'pack_bop__c',
      'packaging__v',
      'pack_fop__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001288',
    statement:
      'Try the Clean Fresh Scent that Sensitive skin has been waiting for',
    qualifier: 'This is the Statement Qualifier',
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001289',
    statement:
      'New all\u00ae fresh & sensitive\u2122 has a clean fresh hypoallergenic scent so its gentle on skin but tough on stains. Now you can have it all.',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001290',
    statement: 'NEW',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001361',
    statement: '100% GREASE REMOVAL 100% STREAK-FREE SHINE',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001362',
    statement: 'WITH LIFT ACTION TECHNOLOGY',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001360',
    statement: 'KITCHEN',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001377',
    statement: 'RHAMN clean TM 00% PLANT-BASED ACTIVE',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001379',
    statement:
      'ANTIBACTERIAL DISHWASHING LIQUID ANTIBACT\u00c9RIEN LIQUIDE VAISSELLE | ANTIBACTERIANA LOU\u00c7AS L\u00cdQUIDO',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001398',
    statement: 'LUX',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'pack_fop__c', 'website__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001400',
    statement: 'Sample Statement',
    qualifier: null,
    marketing_channels: ['pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001401',
    statement: 'Test4',
    qualifier: 'Test4',
    marketing_channels: ['tvc_television_commercial__v', 'website__v'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-001444',
    statement: 'SASSY SWIRL',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001446',
    statement: 'ALL IN JUST 15 MINUTES',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001448',
    statement: 'FLIRTY FLORALS',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001449',
    statement: 'FABULOUS CLEAN BEST EVER FRAGRANCE',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001452',
    statement: 'NEW Surf MAGNIFI-SCENT WASH',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001501',
    statement: 'Testing',
    qualifier: 'Testing!!',
    marketing_channels: ['sop__c', 'top__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001445',
    statement: 'GOLDEN BLISS',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001451',
    statement: 'Designed for SHORT CYCLES Even in 15 Minutes',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001447',
    statement: 'WIP design',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001450',
    statement: 'SAVE WATER ENERGY TIME',
    qualifier: null,
    marketing_channels: ['pack_fop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-002450',
    statement: 'New year new products',
    qualifier: 'Qualifier 20 from Brilhante',
    marketing_channels: ['website__v'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-003668',
    statement: 'This is the test claim 2',
    qualifier: 'Omnichannel\nPack BOP',
    marketing_channels: ['ecommerce__c', 'packaging__v'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-003672',
    statement: 'New Statement',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-003757',
    statement: 'Brilhante',
    qualifier: null,
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-001028',
    statement: 'Test2',
    qualifier: null,
    marketing_channels: [
      'pack_bop__c',
      'concept_claim__c',
      'pack_fop__c',
      'ecommerce__c',
      'press_releases__c',
      'social_media__v',
      'pos_material__c',
    ],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-004244',
    statement:
      'Experience the soothing fragrance of new Bold 2in1 Lavender & Camomile Gel Test add',
    qualifier: 'Test new',
    marketing_channels: null,
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004743',
    statement: 'Clean Fresh Scent',
    qualifier: null,
    marketing_channels: ['email__v', 'pos_material__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004744',
    statement: 'Now you can have it all',
    qualifier: null,
    marketing_channels: ['email__v', 'pos_material__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004746',
    statement:
      'Try new all fresh & sensitive\u2122 With a clean fresh hypoallergenic scent its gentle on skin but tough on stains.',
    qualifier: null,
    marketing_channels: ['email__v', 'pos_material__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004745',
    statement: 'stainlifters',
    qualifier: null,
    marketing_channels: ['email__v', 'pos_material__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004747',
    statement: 'WA fresh & sensitive dyc-free',
    qualifier: null,
    marketing_channels: ['email__v', 'pos_material__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000891',
    statement: 'Better Dissolution',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004768',
    statement: 'Surf Surf',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000890',
    statement: 'Machine and Colour care',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004769',
    statement: 'Faster Stain Removal',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004770',
    statement: 'Surf Surf surf',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004772',
    statement: 'Machine and Colour care tide',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004775',
    statement: 'Faster Stain Removal tide',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004778',
    statement: 'Surf Surf surfecel gd',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004779',
    statement: 'Better Dissolution gd',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004781',
    statement: 'Machine and Colour care gd',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004784',
    statement: 'Superior Fragrance gd',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004782',
    statement: 'Specialy designed for machines gd',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004787',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID gdm',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004789',
    statement: 'Machine and Colour care gdm',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004788',
    statement: 'Superior Fragrance gdm',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004790',
    statement: 'Faster Stain Removal gdm',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004791',
    statement: 'Specialy designed for machines gdm',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004793',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID gdma',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004797',
    statement: 'Faster Stain Removal gdma',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004798',
    statement: 'Specialy designed for machines gdma',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004801',
    statement: 'Machine and Colour care gdmab',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004804',
    statement: 'Faster Stain Removal gdmab',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004800',
    statement: 'Specialy designed for machines gdmab',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004803',
    statement: 'Better Dissolution gdmab',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004802',
    statement: 'Superior Fragrance gdmab',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004805',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID gdmab',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004807',
    statement: 'Surf Surf surfecel gdmabc',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004808',
    statement: 'Faster Stain Removal gdmabc',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004811',
    statement: 'Better Dissolution gdmabc',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004815',
    statement: 'Superior Fragrance g1',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004814',
    statement: 'Specialy designed for machines g1',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004817',
    statement: 'Surf Surf surfecel g1',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004813',
    statement: 'Machine and Colour care g1',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004821',
    statement: 'Specialy designed for machines g1a',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004822',
    statement: 'Better Dissolution g1a',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004825',
    statement: 'Machine and Colour care g1a',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004826',
    statement: 'Faster Stain Removal g1a',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004827',
    statement: 'Superior Fragrance g1ab',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004828',
    statement: 'Better Dissolution g1ab',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004832',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1ab',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004830',
    statement: 'Surf Surf surfecel g1ab',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004834',
    statement: 'Specialy designed for machines g1abc',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004837',
    statement: 'Better Dissolution g1abc',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004838',
    statement: 'Surf Surf surfecel g1abc',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004840',
    statement: 'Superior Fragrance g1abc',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004841',
    statement: 'Faster Stain Removal g1abc1',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004845',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1abc1',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004847',
    statement: 'Surf Surf surfecel g1abc1',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004844',
    statement: 'Machine and Colour care g1abc1',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004848',
    statement: 'Specialy designed for machines g1abc2',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004849',
    statement: 'Faster Stain Removal g1abc2',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004851',
    statement: 'Better Dissolution g1abc2',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004853',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1abc2',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004854',
    statement: 'Superior Fragrance g1abc2',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004850',
    statement: 'Surf Surf surfecel g1abc2',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004855',
    statement: 'Faster Stain Removal g1ab2',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004856',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1ab2',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004857',
    statement: 'Surf Surf surfecel g1ab2',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004858',
    statement: 'Machine and Colour care g1ab2',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004859',
    statement: 'Specialy designed for machines g1ab2',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004861',
    statement: 'Superior Fragrance g1ab2',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004867',
    statement: 'Specialy designed for machines g1a2',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004866',
    statement: 'Machine and Colour care g1a2',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004865',
    statement: 'Better Dissolution g1a2',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004767',
    statement: 'Specialy designed for machines',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004766',
    statement: 'Superior Fragrance',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-000888',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004771',
    statement: 'Surf Surf surfecel tide',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004773',
    statement: 'Superior Fragrance tide',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004774',
    statement: 'Better Dissolution tide',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004776',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID tide',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004777',
    statement: 'Specialy designed for machines tide',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004780',
    statement: 'Faster Stain Removal gd',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004783',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID gd',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004785',
    statement: 'Surf Surf surfecel gdm',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004001',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000005',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-004786',
    statement: 'Better Dissolution gdm',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004792',
    statement: 'Superior Fragrance gdma',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004794',
    statement: 'Better Dissolution gdma',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004796',
    statement: 'Surf Surf surfecel gdma',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004795',
    statement: 'Machine and Colour care gdma',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004799',
    statement: 'Surf Surf surfecel gdmab',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004806',
    statement: 'Machine and Colour care gdmabc',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004809',
    statement: 'Superior Fragrance gdmabc',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004810',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID gdmabc',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004812',
    statement: 'Specialy designed for machines gdmabc',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004818',
    statement: 'Better Dissolution g1',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004819',
    statement: 'Faster Stain Removal g1',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004816',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004820',
    statement: 'Superior Fragrance g1a',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004823',
    statement: 'Surf Surf surfecel g1a',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004824',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1a',
    qualifier: 'Qualifier1',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004829',
    statement: 'Specialy designed for machines g1ab',
    qualifier: null,
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004831',
    statement: 'Machine and Colour care g1ab',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004833',
    statement: 'Faster Stain Removal g1ab',
    qualifier: 'test qualifiers',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004835',
    statement: 'Machine and Colour care g1abc',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004836',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1abc',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004839',
    statement: 'Faster Stain Removal g1abc',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004842',
    statement: 'Superior Fragrance g1abc1',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004843',
    statement: 'Specialy designed for machines g1abc1',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004846',
    statement: 'Better Dissolution g1abc1',
    qualifier: '\n',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004852',
    statement: 'Machine and Colour care g1abc2',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004860',
    statement: 'Better Dissolution g1ab2',
    qualifier: '\n',
    marketing_channels: ['ecommerce__c', 'pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004863',
    statement: 'Surf Surf surfecel g1a2',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004862',
    statement: 'BENEFITS OF SURF EXCEL MATIC LIQUID g1a2',
    qualifier: 'Qualifier1',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004864',
    statement: 'Faster Stain Removal g1a2',
    qualifier: 'test qualifiers',
    marketing_channels: ['pack_bop__c', 'ecommerce__c'],
    support_strategy_rich: 'Charan new',
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004868',
    statement: 'Superior Fragrance g1a2',
    qualifier: null,
    marketing_channels: ['pack_bop__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004892',
    statement: 'testcy',
    qualifier:
      '*Vs. UK market leader in bathroom sprays *Tested on most common kitchen surfaces',
    marketing_channels: [
      'pack_bop__c',
      'ecommerce__c',
      'concept_claim__c',
      'pack_fop__c',
    ],
    support_strategy_rich: 'lkj',
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004016',
        'substantiation__vr.description__v': 'asddd',
        'substantiation__vr.name__v': 'SUB-000033',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-004891',
    statement: 'testcx',
    qualifier:
      '*Vs. UK market leader in bathroom sprays *Tested on most common kitchen surfaces',
    marketing_channels: [
      'pack_bop__c',
      'ecommerce__c',
      'concept_claim__c',
      'pack_fop__c',
    ],
    support_strategy_rich: 'iop',
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004014',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000031',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-004890',
    statement: 'testcz',
    qualifier:
      '*Vs. UK market leader in bathroom sprays *Tested on most common kitchen surfaces',
    marketing_channels: ['pack_bop__c', 'ecommerce__c', 'pack_fop__c'],
    support_strategy_rich: 'mnb',
    substantiations: [
      {
        substantiation_link:
          'https://sb-unilever-claims.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000004017',
        'substantiation__vr.description__v': 'Beauty Products',
        'substantiation__vr.name__v': 'SUB-000034',
        'substantiation__vr.substantiation_details__c': null,
      },
    ],
  },
  {
    claim_name: 'CLM-004927',
    statement: 'Test12',
    qualifier: null,
    marketing_channels: ['pack_bop__c', 'press_releases__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-004929',
    statement: 'Test34',
    qualifier: 'Test',
    marketing_channels: [
      'pack_fop__c',
      'sop__c',
      'concept_claim__c',
      'email__v',
    ],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-005106',
    statement: 'Test67',
    qualifier: 'Test67 qualifier',
    marketing_channels: ['social_media__v', 'press_releases__c'],
    support_strategy_rich: null,
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-005214',
    statement: 'test2fx1d',
    qualifier:
      '*Vs. UK market leader in bathroom sprays *Tested on most common kitchen surfaces',
    marketing_channels: [
      'ecommerce__c',
      'pack_fop__c',
      'pack_bop__c',
      'concept_claim__c',
    ],
    support_strategy_rich: 'lkj',
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-005216',
    statement: 'test1fx1d',
    qualifier:
      '*Vs. UK market leader in bathroom sprays *Tested on most common kitchen surfaces',
    marketing_channels: [
      'ecommerce__c',
      'pack_fop__c',
      'pack_bop__c',
      'concept_claim__c',
    ],
    support_strategy_rich: 'iop',
    substantiations: [{}],
  },
  {
    claim_name: 'CLM-005215',
    statement: 'test3xf1d',
    qualifier:
      '*Vs. UK market leader in bathroom sprays *Tested on most common kitchen surfaces',
    marketing_channels: ['ecommerce__c', 'pack_fop__c', 'pack_bop__c'],
    support_strategy_rich: 'mnb',
    substantiations: [{}],
  },
];

@Injectable({
  providedIn: 'root',
})
export class SubstantiationService {
  constructor(private http: HttpClient) {}
  getClaims(): Observable<any> {
    return of(MOCK_JSON);
  }

  getSubstantiationDetails(data): Observable<any> {
    const url = Const.connectionUrl + '/api/substantiation_details';
    return this.http.post(url, data);
  }

  Json_Mock_SavedSession = [
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          name: 'SUB-225294',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225294',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          name: 'SUB-225293',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225293',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'hest',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          name: 'SUB-216963',
          substantiation_details: '',
          substantiation_id: 'SUB-216963',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U011',
      claim_la_name: 'CLM-087782',
      expandedData: [],
      flg: false,
      marketing_channels: ['Pack BOP', 'Pack FOP', 'POS Material'],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U011',
        claim_la_name: 'CLM-087782',
        marketing_channels: ['Pack BOP', 'Pack FOP', 'POS Material'],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
        ],
        qualifier:
          'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle@#$%^&*()!XYZ',
        statement: "Teeth are completely resealed, so pain doesn't come back.",
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
            'substantiation__vr.name__v': 'SUB-225294',
            'substantiation__vr.substantiation_details__c':
              'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          },
          {
            'country__cr.name__v': 'Brazil',
            'related_reference__vr.subtype__v': 'Packaging Reference',
            'substantiation__vr.description__v':
              'Stain Removal Gaia Final_Liquid',
            'substantiation__vr.name__v': 'SUB-000015',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          },
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
            'substantiation__vr.name__v': 'SUB-225293',
            'substantiation__vr.substantiation_details__c':
              'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Other',
            'substantiation__vr.description__v': null,
            'substantiation__vr.name__v': 'SUB-000014',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'hest',
            'substantiation__vr.name__v': 'SUB-216963',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Dossier Support added',
            'substantiation__vr.name__v': 'SUB-216960',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
        ],
        support_strategy_rich:
          'check highlight from save draft in new implementation',
      },
      originalMarketingChannels: ['Pack BOP', 'Pack FOP', 'POS Material'],
      originalQualifier: [
        'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle@#$%^&*()!XYZ',
      ],
      originalSubstantiations: [
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          name: 'SUB-225294',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225294',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          name: 'SUB-225293',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225293',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'hest',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          name: 'SUB-216963',
          substantiation_details: '',
          substantiation_id: 'SUB-216963',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'check highlight from save draft in new implementation',
      originalText: "Teeth are completely resealed, so pain doesn't come back.",
      project_exist: false,
      qualifier: [
        'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle@#$%^&*()!XYZ',
      ],
      rowType: '',
      savedraft_data: [],
      slno: '01',
      statement: "Teeth are completely resealed, so pain doesn't come back.",
      substantiations: [
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          name: 'SUB-225294',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225294',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          name: 'SUB-225293',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225293',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'hest',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          name: 'SUB-216963',
          substantiation_details: '',
          substantiation_id: 'SUB-216963',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste", Stain Removal Gaia Final_Liquid, Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate", , test123 description, hest, Dossier Support added, testing123',
      support_strategy_rich:
        'check highlight from save draft in new implementation',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Suporte Claim Cuida do meio ambiente',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          name: 'SUB-000019',
          substantiation_details: '',
          substantiation_id: 'SUB-000019',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Support Claim Exclusive perfume that lasts longer',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          name: 'SUB-000020',
          substantiation_details: '',
          substantiation_id: 'SUB-000020',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U012',
      claim_la_name: 'CLM-087783',
      expandedData: [],
      flg: false,
      marketing_channels: ['Pack FOP', 'Print'],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U012',
        claim_la_name: 'CLM-087783',
        marketing_channels: ['Pack FOP', 'Print'],
        marketing_channels_backendname: ['pack_fop__c', 'email__v'],
        qualifier:
          'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
        statement:
          'Sensitive teeth are a sign the protective mineral layer of your enamel is weakened.  When the sensitive areas are exposed; hot and cold sensations can reach the nerves, causing pain.',
        substantiations: [
          {
            'country__cr.name__v': 'Brazil',
            'related_reference__vr.subtype__v': 'Packaging Reference',
            'substantiation__vr.description__v':
              'Stain Removal Gaia Final_Liquid',
            'substantiation__vr.name__v': 'SUB-000015',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Other',
            'substantiation__vr.description__v': null,
            'substantiation__vr.name__v': 'SUB-000014',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          },
          {
            'country__cr.name__v': 'Brazil',
            'related_reference__vr.subtype__v': 'Other',
            'substantiation__vr.description__v':
              'Suporte Claim Cuida do meio ambiente',
            'substantiation__vr.name__v': 'SUB-000019',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          },
          {
            'country__cr.name__v': 'Brazil',
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v':
              'Support Claim Exclusive perfume that lasts longer',
            'substantiation__vr.name__v': 'SUB-000020',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          },
        ],
        support_strategy_rich: 'From app to LA',
      },
      originalMarketingChannels: ['Pack FOP', 'Print'],
      originalQualifier: [
        'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
      ],
      originalSubstantiations: [
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Suporte Claim Cuida do meio ambiente',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          name: 'SUB-000019',
          substantiation_details: '',
          substantiation_id: 'SUB-000019',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Support Claim Exclusive perfume that lasts longer',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          name: 'SUB-000020',
          substantiation_details: '',
          substantiation_id: 'SUB-000020',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy: 'From app to LA',
      originalText:
        'Sensitive teeth are a sign the protective mineral layer of your enamel is weakened.  When the sensitive areas are exposed; hot and cold sensations can reach the nerves, causing pain.',
      project_exist: false,
      qualifier: [
        'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
      ],
      rowType: '',
      savedraft_data: [],
      slno: '02',
      statement:
        'Sensitive teeth are a sign the protective mineral layer of your enamel is weakened.  When the sensitive areas are exposed; hot and cold sensations can reach the nerves, causing pain.',
      substantiations: [
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Suporte Claim Cuida do meio ambiente',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          name: 'SUB-000019',
          substantiation_details: '',
          substantiation_id: 'SUB-000019',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Support Claim Exclusive perfume that lasts longer',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          name: 'SUB-000020',
          substantiation_details: '',
          substantiation_id: 'SUB-000020',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Stain Removal Gaia Final_Liquid, , Suporte Claim Cuida do meio ambiente, Support Claim Exclusive perfume that lasts longer',
      support_strategy_rich: 'From app to LA',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          name: 'SUB-225296',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225296',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          name: 'SUB-225297',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225297',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U013',
      claim_la_name: 'CLM-087784',
      expandedData: [],
      flg: false,
      marketing_channels: ['Print'],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U013',
        claim_la_name: 'CLM-087784',
        marketing_channels: ['Print'],
        marketing_channels_backendname: ['email__v'],
        qualifier:
          'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
        statement:
          'Why use this toothpaste?  It treats pain caused by sensitivity and stops it from coming back with regular use*. Its ActivRemin Technology integrate into your teeth to rebuild weakened enamel that is causing pain.',
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
            'substantiation__vr.name__v': 'SUB-225296',
            'substantiation__vr.substantiation_details__c':
              'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          },
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
            'substantiation__vr.name__v': 'SUB-225297',
            'substantiation__vr.substantiation_details__c':
              'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Other',
            'substantiation__vr.description__v': null,
            'substantiation__vr.name__v': 'SUB-000014',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          },
          {
            'country__cr.name__v': 'Brazil',
            'related_reference__vr.subtype__v': 'Packaging Reference',
            'substantiation__vr.description__v':
              'Stain Removal Gaia Final_Liquid',
            'substantiation__vr.name__v': 'SUB-000015',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Laboratory test',
            'substantiation__vr.name__v': 'SUB-216957',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          },
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Substantiation statement for CLaim 1a',
            'substantiation__vr.name__v': 'SUB-001904',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Dossier Support added',
            'substantiation__vr.name__v': 'SUB-216960',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          },
        ],
        support_strategy_rich: 'From app to LA',
      },
      originalMarketingChannels: ['Print'],
      originalQualifier: [
        'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
      ],
      originalSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          name: 'SUB-225296',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225296',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          name: 'SUB-225297',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225297',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy: 'From app to LA',
      originalText:
        'Why use this toothpaste?  It treats pain caused by sensitivity and stops it from coming back with regular use*. Its ActivRemin Technology integrate into your teeth to rebuild weakened enamel that is causing pain.',
      project_exist: false,
      qualifier: [
        'Laboratory test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
      ],
      rowType: '',
      savedraft_data: [],
      slno: '03',
      statement:
        'Why use this toothpaste?  It treats pain caused by sensitivity and stops it from coming back with regular use*. Its ActivRemin Technology integrate into your teeth to rebuild weakened enamel that is causing pain.',
      substantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          name: 'SUB-225296',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225296',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          name: 'SUB-225297',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225297',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          name: 'SUB-000014',
          substantiation_details: '',
          substantiation_id: 'SUB-000014',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Brazil',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate", Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste", test, test123 description, , Stain Removal Gaia Final_Liquid, testing123, Laboratory test, Substantiation statement for CLaim 1a, Dossier Support added',
      support_strategy_rich: 'From app to LA',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          name: 'SUB-225298',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225298',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U014',
      claim_la_name: 'CLM-087785',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U014',
        claim_la_name: 'CLM-087785',
        marketing_channels: [
          'Pack BOP',
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier: 'from Sparci application',
        statement:
          'Minerals integrate deep into the holes to repair the sensitive area.',
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
            'substantiation__vr.name__v': 'SUB-225298',
            'substantiation__vr.substantiation_details__c':
              'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Dossier Support added',
            'substantiation__vr.name__v': 'SUB-216960',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Laboratory test',
            'substantiation__vr.name__v': 'SUB-216957',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          },
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Substantiation statement for CLaim 1a',
            'substantiation__vr.name__v': 'SUB-001904',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          },
        ],
        support_strategy_rich:
          'This claim will be supported by published results of lab tests that show formation of new mineral within dentine tubules.  The results are published in the Journal of Dentistry: In vitro dentine tubule occlusion by a novel toothpaste containing',
      },
      originalMarketingChannels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: ['from Sparci application'],
      originalSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          name: 'SUB-225298',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225298',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'This claim will be supported by published results of lab tests that show formation of new mineral within dentine tubules.  The results are published in the Journal of Dentistry: In vitro dentine tubule occlusion by a novel toothpaste containing',
      originalText:
        'Minerals integrate deep into the holes to repair the sensitive area.',
      project_exist: false,
      qualifier: ['from Sparci application'],
      rowType: '',
      savedraft_data: [],
      slno: '04',
      statement:
        'Minerals integrate deep into the holes to repair the sensitive area.',
      substantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          name: 'SUB-225298',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225298',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate", test123 description, testing123, test, Dossier Support added, Laboratory test, Substantiation statement for CLaim 1a',
      support_strategy_rich:
        'This claim will be supported by published results of lab tests that show formation of new mineral within dentine tubules.  The results are published in the Journal of Dentistry: In vitro dentine tubule occlusion by a novel toothpaste containing',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          name: 'SUB-225299',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225299',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U016',
      claim_la_name: 'CLM-087787',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U016',
        claim_la_name: 'CLM-087787',
        marketing_channels: [
          'Pack BOP',
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier: 'With regular use, twice daily',
        statement: "Pain doesn't come back",
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
            'substantiation__vr.name__v': 'SUB-225299',
            'substantiation__vr.substantiation_details__c':
              'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Substantiation statement for CLaim 1a',
            'substantiation__vr.name__v': 'SUB-001904',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Laboratory test',
            'substantiation__vr.name__v': 'SUB-216957',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Claims Test',
            'substantiation__vr.description__v': 'Dossier Support added',
            'substantiation__vr.name__v': 'SUB-216960',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          },
        ],
        support_strategy_rich:
          "This claim will be supported by the published clinical study in the Journal of Dentistry which showed relief of sensitivity pain over 4 weeks brushing.  The disclaimer on 'with regular twice daily use' is important.",
      },
      originalMarketingChannels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: ['With regular use, twice daily'],
      originalSubstantiations: [
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          name: 'SUB-225299',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225299',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        "This claim will be supported by the published clinical study in the Journal of Dentistry which showed relief of sensitivity pain over 4 weeks brushing.  The disclaimer on 'with regular twice daily use' is important.",
      originalText: "Pain doesn't come back",
      project_exist: false,
      qualifier: ['With regular use, twice daily'],
      rowType: '',
      savedraft_data: [],
      slno: '05',
      statement: "Pain doesn't come back",
      substantiations: [
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          name: 'SUB-225299',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225299',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Substantiation statement for CLaim 1a',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          name: 'SUB-001904',
          substantiation_details: '',
          substantiation_id: 'SUB-001904',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Laboratory test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          name: 'SUB-216957',
          substantiation_details: '',
          substantiation_id: 'SUB-216957',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Dossier Support added',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          name: 'SUB-216960',
          substantiation_details: '',
          substantiation_id: 'SUB-216960',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
          subtype: 'Claims Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste", test, Substantiation statement for CLaim 1a, Laboratory test, testing123, test123 description, Dossier Support added',
      support_strategy_rich:
        "This claim will be supported by the published clinical study in the Journal of Dentistry which showed relief of sensitivity pain over 4 weeks brushing.  The disclaimer on 'with regular twice daily use' is important.",
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'REP0154: Increase in dentine microhardness following brushing with CSSP toothpaste, Novamin toothpaste and a fluoride only toothpaste',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          name: 'SUB-225300',
          substantiation_details: '',
          substantiation_id: 'SUB-225300',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          subtype: 'Laboratory Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U019',
      claim_la_name: 'CLM-087790',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U019',
        claim_la_name: 'CLM-087790',
        marketing_channels: [
          'Pack BOP',
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier:
          'Based on a lab test. 20 times increase in change in surface microhardness over 4 days compared to baseline / no treatment',
        statement:
          "Pepsodent Sensitivexpert uses patented ActivRemin to form the exact same minerals that teeth are made of.  It completely fills the exposed areas by building a 20 x stronger natural mineral layer.**  Teeth are resealed, restoring the protective power of enamel so pain doesn't come back.*",
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': 'Laboratory Test',
            'substantiation__vr.description__v':
              'REP0154: Increase in dentine microhardness following brushing with CSSP toothpaste, Novamin toothpaste and a fluoride only toothpaste',
            'substantiation__vr.name__v': 'SUB-225300',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
        ],
        support_strategy_rich:
          'This statement will be supported by the results of a dentine remineralisation microhardness study (REP0154) which showed a significant increase in dentine microhardness over 4 days twice a day treatment.  ',
      },
      originalMarketingChannels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: [
        'Based on a lab test. 20 times increase in change in surface microhardness over 4 days compared to baseline / no treatment',
      ],
      originalSubstantiations: [
        {
          description:
            'REP0154: Increase in dentine microhardness following brushing with CSSP toothpaste, Novamin toothpaste and a fluoride only toothpaste',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          name: 'SUB-225300',
          substantiation_details: '',
          substantiation_id: 'SUB-225300',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          subtype: 'Laboratory Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'This statement will be supported by the results of a dentine remineralisation microhardness study (REP0154) which showed a significant increase in dentine microhardness over 4 days twice a day treatment.  ',
      originalText:
        "Pepsodent Sensitivexpert uses patented ActivRemin to form the exact same minerals that teeth are made of.  It completely fills the exposed areas by building a 20 x stronger natural mineral layer.**  Teeth are resealed, restoring the protective power of enamel so pain doesn't come back.*",
      project_exist: false,
      qualifier: [
        'Based on a lab test. 20 times increase in change in surface microhardness over 4 days compared to baseline / no treatment',
      ],
      rowType: '',
      savedraft_data: [],
      slno: '06',
      statement:
        "Pepsodent Sensitivexpert uses patented ActivRemin to form the exact same minerals that teeth are made of.  It completely fills the exposed areas by building a 20 x stronger natural mineral layer.**  Teeth are resealed, restoring the protective power of enamel so pain doesn't come back.*",
      substantiations: [
        {
          description:
            'REP0154: Increase in dentine microhardness following brushing with CSSP toothpaste, Novamin toothpaste and a fluoride only toothpaste',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          name: 'SUB-225300',
          substantiation_details: '',
          substantiation_id: 'SUB-225300',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
          subtype: 'Laboratory Test',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'REP0154: Increase in dentine microhardness following brushing with CSSP toothpaste, Novamin toothpaste and a fluoride only toothpaste, testing123, test, test123 description',
      support_strategy_rich:
        'This statement will be supported by the results of a dentine remineralisation microhardness study (REP0154) which showed a significant increase in dentine microhardness over 4 days twice a day treatment.  ',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U020',
      claim_la_name: 'CLM-087791',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U020',
        claim_la_name: 'CLM-087791',
        marketing_channels: [
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier: 'Based on Nielson market sales data',
        statement: 'No. 1 brand+: Recommended by Pepsodent dental expert',
        substantiations: [
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
        ],
        support_strategy_rich:
          "Will be supported by data from Nielsen and a letter from Alison Green (Oral Care R&D Director) as the designate 'Pepsodent Dental Expert.'",
      },
      originalMarketingChannels: [
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: ['Based on Nielson market sales data'],
      originalSubstantiations: [
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        "Will be supported by data from Nielsen and a letter from Alison Green (Oral Care R&D Director) as the designate 'Pepsodent Dental Expert.'",
      originalText: 'No. 1 brand+: Recommended by Pepsodent dental expert',
      project_exist: false,
      qualifier: ['Based on Nielson market sales data'],
      rowType: '',
      savedraft_data: [],
      slno: '07',
      statement: 'No. 1 brand+: Recommended by Pepsodent dental expert',
      substantiations: [
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString: 'testing123, test, test123 description',
      support_strategy_rich:
        "Will be supported by data from Nielsen and a letter from Alison Green (Oral Care R&D Director) as the designate 'Pepsodent Dental Expert.'",
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U021',
      claim_la_name: 'CLM-087792',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U021',
        claim_la_name: 'CLM-087792',
        marketing_channels: [
          'Pack BOP',
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier: 'from Sparci application',
        statement:
          'ActivRemin technology releases the same natural mineral as the tooth.',
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
            'substantiation__vr.name__v': 'SUB-225301',
            'substantiation__vr.substantiation_details__c':
              'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
        ],
        support_strategy_rich:
          'The claim will be supported by a paper in the Journal of Dentistry which reports how the new mineral formed (HAP) has the same chemical composition and crystal structure as HAP in dentine.  In vitro dentine tubule occlusion by a novel toothpaste',
      },
      originalMarketingChannels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: ['from Sparci application'],
      originalSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'The claim will be supported by a paper in the Journal of Dentistry which reports how the new mineral formed (HAP) has the same chemical composition and crystal structure as HAP in dentine.  In vitro dentine tubule occlusion by a novel toothpaste',
      originalText:
        'ActivRemin technology releases the same natural mineral as the tooth.',
      project_exist: false,
      qualifier: ['from Sparci application'],
      rowType: '',
      savedraft_data: [],
      slno: '08',
      statement:
        'ActivRemin technology releases the same natural mineral as the tooth.',
      substantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate", testing123, test, test123 description',
      support_strategy_rich:
        'The claim will be supported by a paper in the Journal of Dentistry which reports how the new mineral formed (HAP) has the same chemical composition and crystal structure as HAP in dentine.  In vitro dentine tubule occlusion by a novel toothpaste',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U023',
      claim_la_name: 'CLM-087794',
      expandedData: [],
      flg: true,
      marketing_channels: [
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U023',
        claim_la_name: 'CLM-087794',
        marketing_channels: [
          'POS Material',
          'Press Releases',
          // "Pack FOP",
          // "Print"
        ],
        marketing_channels_backendname: [
          'pos_material__c',
          'press_releases__c',
          // "pack_fop__c",
          // "email__v"
        ],
        qualifier: null,
        statement: 'Max Repair new claim',
        substantiations: [
          // {
          //     "country__cr.name__v": null,
          //     "related_reference__vr.subtype__v": "Survey",
          //     "substantiation__vr.description__v": "test123 description",
          //     "substantiation__vr.name__v": "SUB-378965",
          //     "substantiation__vr.substantiation_details__c": "test123 details",
          //     "substantiation_link": "https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016"
          // },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
        ],
        support_strategy_rich:
          "from latest change Variant name.  'Max Repair' because this is the most efficacious technology in the Unilever portfolio ",
      },
      originalMarketingChannels: [
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: ['from Sparci application'],
      originalSubstantiations: [
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        "Variant name.  'Max Repair' because this is the most efficacious technology in the Unilever portfolio ",
      originalText: 'Max Repair',
      project_exist: false,
      qualifier: ['from Sparci application'],
      rowType: '',
      savedraft_data: [],
      slno: '09',
      statement: 'Max Repair',
      substantiations: [
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString: 'test123 description, testing123, test',
      support_strategy_rich:
        "Variant name.  'Max Repair' because this is the most efficacious technology in the Unilever portfolio ",
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          name: 'SUB-225299',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225299',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U024',
      claim_la_name: 'CLM-087795',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U024',
        claim_la_name: 'CLM-087795',
        marketing_channels: [
          'Pack BOP',
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier: 'Relief of sensitivity is proven in a clinical study',
        statement: '100% proven*',
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
            'substantiation__vr.name__v': 'SUB-225301',
            'substantiation__vr.substantiation_details__c':
              'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          },
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
            'substantiation__vr.name__v': 'SUB-225299',
            'substantiation__vr.substantiation_details__c':
              'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
        ],
        support_strategy_rich:
          "The support strategy here will be to use the published clinical and in-vitro evidence for the efficacy of the product to relieve sensitivity by occluding dentinal tubules.  We are intending '100% proven' to mean that we have evidence as to the",
      },
      originalMarketingChannels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: [
        'Relief of sensitivity is proven in a clinical study',
      ],
      originalSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          name: 'SUB-225299',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225299',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        "The support strategy here will be to use the published clinical and in-vitro evidence for the efficacy of the product to relieve sensitivity by occluding dentinal tubules.  We are intending '100% proven' to mean that we have evidence as to the",
      originalText: '100% proven*',
      project_exist: false,
      qualifier: ['Relief of sensitivity is proven in a clinical study'],
      rowType: '',
      savedraft_data: [],
      slno: '10',
      statement: '100% proven*',
      substantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          name: 'SUB-225299',
          substantiation_details:
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_id: 'SUB-225299',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate", Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste", testing123, test, test123 description',
      support_strategy_rich:
        "The support strategy here will be to use the published clinical and in-vitro evidence for the efficacy of the product to relieve sensitivity by occluding dentinal tubules.  We are intending '100% proven' to mean that we have evidence as to the",
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V1900000007U027',
      claim_la_name: 'CLM-087798',
      expandedData: [],
      flg: false,
      marketing_channels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V1900000007U027',
        claim_la_name: 'CLM-087798',
        marketing_channels: [
          'Pack BOP',
          'Pack FOP',
          'POS Material',
          'Press Releases',
          'Print',
        ],
        marketing_channels_backendname: [
          'pack_bop__c',
          'pack_fop__c',
          'pos_material__c',
          'press_releases__c',
          'email__v',
        ],
        qualifier: 'from Sparci application',
        statement:
          'Weakened enamel can expose tiny holes in the dentine to cause sensitivity pain.',
        substantiations: [
          {
            'country__cr.name__v': 'Global',
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
            'substantiation__vr.name__v': 'SUB-225301',
            'substantiation__vr.substantiation_details__c':
              'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Research Institute Letter',
            'substantiation__vr.description__v': 'test',
            'substantiation__vr.name__v': 'SUB-378966',
            'substantiation__vr.substantiation_details__c': null,
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Survey',
            'substantiation__vr.description__v': 'test123 description',
            'substantiation__vr.name__v': 'SUB-378965',
            'substantiation__vr.substantiation_details__c': 'test123 details',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v':
              'Capture Supplier Literature/Certification',
            'substantiation__vr.description__v': 'testing123',
            'substantiation__vr.name__v': 'SUB-378967',
            'substantiation__vr.substantiation_details__c': 'testing123',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          },
        ],
        support_strategy_rich:
          'Factual point well understood and accepted by dentists and dental researchers. No substantiation needed',
      },
      originalMarketingChannels: [
        'Pack BOP',
        'Pack FOP',
        'POS Material',
        'Press Releases',
        'Print',
      ],
      originalQualifier: ['from Sparci application'],
      originalSubstantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'Factual point well understood and accepted by dentists and dental researchers. No substantiation needed',
      originalText:
        'Weakened enamel can expose tiny holes in the dentine to cause sensitivity pain.',
      project_exist: false,
      qualifier: ['from Sparci application'],
      rowType: '',
      savedraft_data: [],
      slno: '11',
      statement:
        'Weakened enamel can expose tiny holes in the dentine to cause sensitivity pain.',
      substantiations: [
        {
          description:
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: 'Global',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          name: 'SUB-225301',
          substantiation_details:
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_id: 'SUB-225301',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          name: 'SUB-378966',
          substantiation_details: '',
          substantiation_id: 'SUB-378966',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
          subtype: 'Research Institute Letter',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'test123 description',
          details: 'test123 details',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          name: 'SUB-378965',
          substantiation_details: 'test123 details',
          substantiation_id: 'SUB-378965',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
          subtype: 'Survey',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'testing123',
          details: 'testing123',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          name: 'SUB-378967',
          substantiation_details: 'testing123',
          substantiation_id: 'SUB-378967',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate", test, test123 description, testing123',
      support_strategy_rich:
        'Factual point well understood and accepted by dentists and dental researchers. No substantiation needed',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          name: 'SUB-219733',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219733',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          name: 'SUB-219734',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219734',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          name: 'SUB-219735',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219735',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          name: 'SUB-219736',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219736',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          name: 'SUB-219737',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219737',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          name: 'SUB-219738',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219738',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V190000000CO008',
      claim_la_name: 'CLM-173374',
      expandedData: [],
      flg: false,
      marketing_channels: ['Pack BOP'],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V190000000CO008',
        claim_la_name: 'CLM-173374',
        marketing_channels: ['Pack BOP'],
        marketing_channels_backendname: ['pack_bop__c'],
        qualifier: null,
        statement: 'Clinically tested efficacy',
        substantiations: [
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'Clinically tested efficacy',
            'substantiation__vr.name__v': 'SUB-219733',
            'substantiation__vr.substantiation_details__c':
              'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'Clinically tested efficacy',
            'substantiation__vr.name__v': 'SUB-219734',
            'substantiation__vr.substantiation_details__c':
              'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'Clinically tested efficacy',
            'substantiation__vr.name__v': 'SUB-219735',
            'substantiation__vr.substantiation_details__c':
              'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'Clinically tested efficacy',
            'substantiation__vr.name__v': 'SUB-219736',
            'substantiation__vr.substantiation_details__c':
              'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'Clinically tested efficacy',
            'substantiation__vr.name__v': 'SUB-219737',
            'substantiation__vr.substantiation_details__c':
              'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v': 'Clinically tested efficacy',
            'substantiation__vr.name__v': 'SUB-219738',
            'substantiation__vr.substantiation_details__c':
              'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          },
        ],
        support_strategy_rich:
          'Clinically tested efficacy - The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so',
      },
      originalMarketingChannels: ['Pack BOP'],
      originalQualifier: [],
      originalSubstantiations: [
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          name: 'SUB-219733',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219733',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          name: 'SUB-219734',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219734',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          name: 'SUB-219735',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219735',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          name: 'SUB-219736',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219736',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          name: 'SUB-219737',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219737',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          name: 'SUB-219738',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219738',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'Clinically tested efficacy - The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so',
      originalText: 'Clinically tested efficacy',
      project_exist: false,
      qualifier: [],
      rowType: '',
      savedraft_data: [],
      slno: '12',
      statement: 'Clinically tested efficacy',
      substantiations: [
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          name: 'SUB-219733',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219733',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW177',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          name: 'SUB-219734',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219734',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW178',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          name: 'SUB-219735',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219735',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW179',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          name: 'SUB-219736',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219736',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW180',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          name: 'SUB-219737',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219737',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW181',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Clinically tested efficacy',
          details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          name: 'SUB-219738',
          substantiation_details:
            'The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so reducing gum inflammation ',
          substantiation_id: 'SUB-219738',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AW182',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Clinically tested efficacy, Clinically tested efficacy, Clinically tested efficacy, Clinically tested efficacy, Clinically tested efficacy, Clinically tested efficacy',
      support_strategy_rich:
        'Clinically tested efficacy - The product contains the active ingredients F as SMFP, 2% zn citrate, 5.35% potassium citrate and 2% hydroxyapatite.  The efficacy of Fluoride to help prevent cavities, Zinc to act as an antibacterial, antiplaque agent so',
    },
    {
      _userAddedSubstantiations: [],
      apiSubstantiations: [
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          name: 'SUB-218423',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218423',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          name: 'SUB-218424',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218424',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          name: 'SUB-218425',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218425',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'ORL-SEN-1274 Relief of sensitivity in 8 hours',
          details:
            'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          name: 'SUB-224228',
          substantiation_details:
            'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
          substantiation_id: 'SUB-224228',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Summary of scientific evidence for the Sensitive Expert formulation',
          details:
            'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          name: 'SUB-224843',
          substantiation_details:
            'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
          substantiation_id: 'SUB-224843',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V190000000CO007',
      claim_la_name: 'CLM-173373',
      expandedData: [],
      flg: false,
      marketing_channels: ['Pack FOP'],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V190000000CO007',
        claim_la_name: 'CLM-173373',
        marketing_channels: ['Pack FOP'],
        marketing_channels_backendname: ['pack_fop__c'],
        qualifier: null,
        statement: 'Remineralizes sensitive teeth.  Long lasting protection',
        substantiations: [
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Remineralizes teeth and protect teeth from demineralization',
            'substantiation__vr.name__v': 'SUB-218423',
            'substantiation__vr.substantiation_details__c':
              "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Remineralizes teeth and protect teeth from demineralization',
            'substantiation__vr.name__v': 'SUB-218424',
            'substantiation__vr.substantiation_details__c':
              "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Remineralizes teeth and protect teeth from demineralization',
            'substantiation__vr.name__v': 'SUB-218425',
            'substantiation__vr.substantiation_details__c':
              "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Other',
            'substantiation__vr.description__v':
              'ORL-SEN-1274 Relief of sensitivity in 8 hours',
            'substantiation__vr.name__v': 'SUB-224228',
            'substantiation__vr.substantiation_details__c':
              'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          },
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': 'Other',
            'substantiation__vr.description__v':
              'Summary of scientific evidence for the Sensitive Expert formulation',
            'substantiation__vr.name__v': 'SUB-224843',
            'substantiation__vr.substantiation_details__c':
              'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          },
        ],
        support_strategy_rich:
          'ORL-SEN-1274 Relief of sensitivity in 8 hours - A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks ',
      },
      originalMarketingChannels: ['Pack FOP'],
      originalQualifier: [],
      originalSubstantiations: [
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          name: 'SUB-218423',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218423',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          name: 'SUB-218424',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218424',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          name: 'SUB-218425',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218425',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'ORL-SEN-1274 Relief of sensitivity in 8 hours',
          details:
            'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          name: 'SUB-224228',
          substantiation_details:
            'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
          substantiation_id: 'SUB-224228',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Summary of scientific evidence for the Sensitive Expert formulation',
          details:
            'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          name: 'SUB-224843',
          substantiation_details:
            'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
          substantiation_id: 'SUB-224843',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'ORL-SEN-1274 Relief of sensitivity in 8 hours - A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks ',
      originalText: 'Remineralizes sensitive teeth.  Long lasting protection',
      project_exist: false,
      qualifier: [],
      rowType: '',
      savedraft_data: [],
      slno: '13',
      statement: 'Remineralizes sensitive teeth.  Long lasting protection',
      substantiations: [
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          name: 'SUB-218423',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218423',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU789',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          name: 'SUB-218424',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218424',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU790',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Remineralizes teeth and protect teeth from demineralization',
          details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          name: 'SUB-218425',
          substantiation_details:
            "'Mentadent Professional Protect + helps to extend the life of teeth, keeping them healthy and strong over time '. In contrast to the natural teeth erosion is proven that this toothpaste is able to remineralize acid demineralized teeth and to protect ",
          substantiation_id: 'SUB-218425',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AU791',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'ORL-SEN-1274 Relief of sensitivity in 8 hours',
          details:
            'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          name: 'SUB-224228',
          substantiation_details:
            'A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks and 8 weeks.',
          substantiation_id: 'SUB-224228',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B0909',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description:
            'Summary of scientific evidence for the Sensitive Expert formulation',
          details:
            'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          name: 'SUB-224843',
          substantiation_details:
            'A summary of the scientific evidence for the Sensitive Expert formulation with SMFP, zinc citrate, potassium citrate and HAP',
          substantiation_id: 'SUB-224843',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B1535',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      substantiationsString:
        'Remineralizes teeth and protect teeth from demineralization, Remineralizes teeth and protect teeth from demineralization, Remineralizes teeth and protect teeth from demineralization, ORL-SEN-1274 Relief of sensitivity in 8 hours, Summary of scientific evidence for the Sensitive Expert formulation',
      support_strategy_rich:
        'ORL-SEN-1274 Relief of sensitivity in 8 hours - A clinical study which demonstrates relief of sensitivity with a formulation containing SMFP, potassium citrate, zinc citrate and HAP.  The measurement points were baseline, 30 secs, 8 hours, 4 weeks ',
    },
    {
      _userAddedSubstantiations: [
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/121605/0/1',
          document_name: 'Skincare_productefinal.txt',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
      ],
      apiSubstantiations: [
        {
          description: 'Teeth are made from hydroxyapatite HAP',
          details:
            'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          name: 'SUB-221034',
          substantiation_details:
            'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
          substantiation_id: 'SUB-221034',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V190000000CO005',
      claim_la_name: 'CLM-173371',
      expandedData: [],
      flg: true,
      marketing_channels: ['Pack BOP'],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V190000000CO005',
        claim_la_name: 'CLM-173371',
        marketing_channels: ['Pack BOP'],
        marketing_channels_backendname: ['pack_bop__c'],
        qualifier: null,
        statement: 'Bio-compatible minerals',
        substantiations: [
          {
            'country__cr.name__v': null,
            'related_reference__vr.subtype__v': null,
            'substantiation__vr.description__v':
              'Teeth are made from hydroxyapatite HAP',
            'substantiation__vr.name__v': 'SUB-221034',
            'substantiation__vr.substantiation_details__c':
              'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
            substantiation_link:
              'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          },
        ],
        support_strategy_rich:
          'Teeth are made from hydroxyapatite HAP - Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence ',
      },
      originalMarketingChannels: ['Pack BOP'],
      originalQualifier: [],
      originalSubstantiations: [
        {
          description: 'Teeth are made from hydroxyapatite HAP',
          details:
            'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          name: 'SUB-221034',
          substantiation_details:
            'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
          substantiation_id: 'SUB-221034',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy:
        'Teeth are made from hydroxyapatite HAP - Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence ',
      originalText: 'Bio-compatible minerals',
      project_exist: false,
      qualifier: [],
      rowType: '',
      savedraft_data: [],
      slno: '14',
      statement: 'Bio-compatible minerals',
      substantiations: [
        {
          description: 'Teeth are made from hydroxyapatite HAP',
          details:
            'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          name: 'SUB-221034',
          substantiation_details:
            'Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence of HAP within the formulation and HAP is a',
          substantiation_id: 'SUB-221034',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AX544',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/121605/0/1',
          document_name: 'Skincare_productefinal.txt',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
      ],
      substantiationsString: 'SUB-221034,SUB-000015',
      support_strategy_rich:
        'Teeth are made from hydroxyapatite HAP - Bio-compatible is a word used to describe something that does not have a harmful effect on the human body. https://dictionary.cambridge.org/dictionary/english/biocompatibleThe word is related to the presence ',
    },
    {
      _userAddedSubstantiations: [
        {
          description: 'Support Claim Exclusive perfume that lasts longer',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/265/0/1',
          document_name: 'Fragr ncia - OLP',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          name: 'SUB-000020',
          substantiation_details: '',
          substantiation_id: 'SUB-000020',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
        {
          description: 'Suporte Claim Cuida do meio ambiente',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/266/0/1',
          document_name: 'REDU  O GHG',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          name: 'SUB-000019',
          substantiation_details: '',
          substantiation_id: 'SUB-000019',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/121605/0/1',
          document_name: 'Skincare_productefinal.txt',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
      ],
      apiSubstantiations: [
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: '',
          name: '',
          substantiation_details: '',
          substantiation_id: '',
          substantiation_link: '',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      claim_la_bid: 'V190000000FE010',
      claim_la_name: 'CLM-177879',
      expandedData: [],
      flg: true,
      marketing_channels: [],
      master_exist: false,
      new_claim_data: {
        claim_la_bid: 'V190000000FE010',
        claim_la_name: 'CLM-177879',
        marketing_channels: null,
        marketing_channels_backendname: null,
        qualifier: null,
        statement: 'testing save draft highlights',
        substantiations: [],
        support_strategy_rich: null,
      },
      originalMarketingChannels: [],
      originalQualifier: [],
      originalSubstantiations: [
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: '',
          name: '',
          substantiation_details: '',
          substantiation_id: '',
          substantiation_link: '',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
      ],
      originalSupportStrategy: '',
      originalText: 'testing save draft highlights',
      project_exist: false,
      qualifier: [],
      rowType: '',
      savedraft_data: [],
      slno: '15',
      statement: 'testing save draft highlights',
      substantiations: [
        {
          description: '',
          details: '',
          document_link: '',
          document_name: '',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: false,
          link: '',
          name: '',
          substantiation_details: '',
          substantiation_id: '',
          substantiation_link: '',
          subtype: '',
          support_strategy_rich: '',
          textColorClass: 'statement-grey',
        },
        {
          description: 'Support Claim Exclusive perfume that lasts longer',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/265/0/1',
          document_name: 'Fragr ncia - OLP',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          name: 'SUB-000020',
          substantiation_details: '',
          substantiation_id: 'SUB-000020',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
          subtype: 'Capture Supplier Literature/Certification',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
        {
          description: 'Suporte Claim Cuida do meio ambiente',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/266/0/1',
          document_name: 'REDU  O GHG',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          name: 'SUB-000019',
          substantiation_details: '',
          substantiation_id: 'SUB-000019',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
          subtype: 'Other',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
        {
          description: 'Stain Removal Gaia Final_Liquid',
          details: '',
          document_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#doc_info/121605/0/1',
          document_name: 'Skincare_productefinal.txt',
          fromClaimSubst: false,
          geography: '',
          isUserAdded: true,
          link: 'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          name: 'SUB-000015',
          substantiation_details: '',
          substantiation_id: 'SUB-000015',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
          subtype: 'Packaging Reference',
          support_strategy_rich: '',
          textColorClass: 'statement-dark-grey',
        },
      ],
      substantiationsString: ',SUB-000020,SUB-000019,SUB-000015',
      support_strategy_rich: '',
    },
    {
      claim_la_bid: 'V190000000FE021',
      claim_la_name: 'CLM-177903',
      marketing_channels: ['Pack BOP', 'Pack FOP'],
      marketing_channels_backendname: ['pack_bop__c', 'pack_fop__c'],
      qualifier: 'Result of a lab test</p>',
      statement:
        'Area gigi sensitif sepenuhnya tertutup untuk mencegah ngilu datang kembali*.',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE011',
      claim_la_name: 'CLM-177883',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: 'test',
      statement: 'demo_12',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF014',
      claim_la_name: 'CLM-177902',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF027',
      claim_la_name: 'CLM-177927',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 50000000',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000EY014',
      claim_la_name: 'CLM-177366',
      marketing_channels: [
        'Pack FOP',
        'Press Releases',
        'POS Material',
        'Print',
        'Pack BOP',
      ],
      marketing_channels_backendname: [
        'pack_fop__c',
        'press_releases__c',
        'pos_material__c',
        'email__v',
        'pack_bop__c',
      ],
      qualifier: 'to add the qualifier for in use statement',
      statement: 'Test',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225301',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
        },
      ],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE017',
      claim_la_name: 'CLM-177893',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 30000000000000',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FB132',
      claim_la_name: 'CLM-177861',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 4000000',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF005',
      claim_la_name: 'CLM-177886',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: 'test',
      statement: 'demo_13',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF011',
      claim_la_name: 'CLM-177899',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_11',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF028',
      claim_la_name: 'CLM-177929',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_21',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE020',
      claim_la_name: 'CLM-177898',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_11',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE022',
      claim_la_name: 'CLM-177904',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo_09',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF012',
      claim_la_name: 'CLM-177900',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_12',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF016',
      claim_la_name: 'CLM-177907',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'hello',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE002',
      claim_la_name: 'CLM-177870',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE034',
      claim_la_name: 'CLM-177930',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_23',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF010',
      claim_la_name: 'CLM-177896',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_12',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE016',
      claim_la_name: 'CLM-177890',
      marketing_channels: ['Omnichannel'],
      marketing_channels_backendname: ['packaging__v'],
      qualifier: 'test_20',
      statement: 'demo_20',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE032',
      claim_la_name: 'CLM-177924',
      marketing_channels: ['Press Releases'],
      marketing_channels_backendname: ['press_releases__c'],
      qualifier: 'data',
      statement: 'Max Repair two',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE012',
      claim_la_name: 'CLM-177884',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo_11',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE018',
      claim_la_name: 'CLM-177895',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_13',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF015',
      claim_la_name: 'CLM-177906',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test234',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FC121',
      claim_la_name: 'CLM-177868',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 12313123123',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF007',
      claim_la_name: 'CLM-177891',
      marketing_channels: ['E-Commerce'],
      marketing_channels_backendname: ['ecommerce__c'],
      qualifier: 'test_23',
      statement: 'demo_23',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE013',
      claim_la_name: 'CLM-177885',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo_14',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF032',
      claim_la_name: 'CLM-177936',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test demo',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF009',
      claim_la_name: 'CLM-177894',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 500000000000000000000',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE033',
      claim_la_name: 'CLM-177928',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test123123123123123123',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE019',
      claim_la_name: 'CLM-177897',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_14',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FB120',
      claim_la_name: 'CLM-177833',
      marketing_channels: [
        'Concept Claims',
        'Pack FOP',
        'Press Releases',
        'E-Commerce',
        'Omnichannel',
        'POS Material',
        'Print',
        'KV (Key Visual)',
        'Pack BOP',
      ],
      marketing_channels_backendname: [
        'concept_claim__c',
        'pack_fop__c',
        'press_releases__c',
        'ecommerce__c',
        'packaging__v',
        'pos_material__c',
        'email__v',
        'kv_key_visual__c',
        'pack_bop__c',
      ],
      qualifier: 'integration check',
      statement: 'test123',
      substantiations: [
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v': 'hest',
          'substantiation__vr.name__v': 'SUB-216963',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Dossier Support added',
          'substantiation__vr.name__v': 'SUB-216960',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Laboratory test',
          'substantiation__vr.name__v': 'SUB-216957',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
        },
      ],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE023',
      claim_la_name: 'CLM-177905',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 500000000000000000',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF024',
      claim_la_name: 'CLM-177923',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement text 123',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF006',
      claim_la_name: 'CLM-177889',
      marketing_channels: ['Pack BOP'],
      marketing_channels_backendname: ['pack_bop__c'],
      qualifier: 'test_21',
      statement: 'demo_21',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FE005',
      claim_la_name: 'CLM-177873',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo_01',
      substantiations: [],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V190000000FF013',
      claim_la_name: 'CLM-177901',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo',
      substantiations: [],
      support_strategy_rich: null,
    },
  ];

  mockdata_color = [
    {
      claim_la_bid: 'V2Q00000007O005',
      claim_la_id: 'V1900000007U011',
      claim_la_name: 'CLM-087782.ID',
      claim_substantiations: [
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v': null,
          'substantiation__vr.name__v': 'SUB-000014',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Survey',
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
      ],
      global_qualifier: null,
      global_statement:
        "Teeth are completely resealed, so pain doesn't come back.",
      marketing_channels: ['Omnichannel'],
      marketing_channels_backendname: ['packaging__v'],
      qualifier: 'demo',
      statement:
        'Area gigi sensitif sepenuhnya tertutup untuk mencegah ngilu datang kembali*.',
      substantiations: [
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v': null,
          'substantiation__vr.name__v': 'SUB-000014',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Survey',
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          'substantiation__vr.name__v': 'SUB-225294',
          'substantiation__vr.substantiation_details__c':
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3001',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Packaging Reference',
          'substantiation__vr.description__v':
            'Stain Removal Gaia Final_Liquid',
          'substantiation__vr.name__v': 'SUB-000015',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
        },
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225293',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Dossier Support added',
          'substantiation__vr.name__v': 'SUB-216960',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v': 'hest',
          'substantiation__vr.name__v': 'SUB-216963',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v':
            'Capture Supplier Literature/Certification',
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
      ],
      support_strategy_rich:
        'This claim will be supported by1 published results of lab tests that show formation of new mineral within dentine tubules.  The results are published in the Journal of Dentistry: In vitro dentine tubule occlusion by a novel toothpaste containing',
    },
    {
      claim_la_bid: 'V2Q00000007O006',
      claim_la_id: 'V1900000007U012',
      claim_la_name: 'CLM-087783.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement:
        'Sensitive teeth are a sign the protective mineral layer of your enamel is weakened.  When the sensitive areas are exposed; hot and cold sensations can reach the nerves, causing pain.',
      marketing_channels: ['Omnichannel', 'Pack BOP'],
      marketing_channels_backendname: ['packaging__v', 'pack_bop__c'],
      qualifier: 'With regular use test\ntwice a day',
      statement:
        'Gigi sensitif dapat menjadi salah satu tanda melemah atau terbukanya lapisan mineral alami pelindung enamel gigi sehingga sensasi panas dan dingin menjangkau saraf, menyebabkan ngilu.',
      substantiations: [
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v':
            'Suporte Claim Cuida do meio ambiente',
          'substantiation__vr.name__v': 'SUB-000019',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007008',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v':
            'Capture Supplier Literature/Certification',
          'substantiation__vr.description__v':
            'Support Claim Exclusive perfume that lasts longer',
          'substantiation__vr.name__v': 'SUB-000020',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007009',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Packaging Reference',
          'substantiation__vr.description__v':
            'Stain Removal Gaia Final_Liquid',
          'substantiation__vr.name__v': 'SUB-000015',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v': null,
          'substantiation__vr.name__v': 'SUB-000014',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
        },
      ],
      support_strategy_rich:
        'Factual point and the consensus view in the academic literature',
    },
    {
      claim_la_bid: 'V2Q00000007P002',
      claim_la_id: 'V1900000007U013',
      claim_la_name: 'CLM-087784.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement:
        'Why use this toothpaste?  It treats pain caused by sensitivity and stops it from coming back with regular use*. Its ActivRemin Technology integrate into your teeth to rebuild weakened enamel that is causing pain.',
      marketing_channels: ['SOP'],
      marketing_channels_backendname: ['sop__c'],
      qualifier: '*with regular use, twice daily',
      statement:
        'Mengapa menggunakan pasta gigi ini?\nPasta gigi ini meredakan ngilu karena gigi sensitif dan mencegahnya datang kembali dengan pemakaian teratur*. Tekonologi ActivRemin TM menyatu dengan gigi anda dan mengembalikan lapisan email gigi penyebab gigi ngilu.',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225296',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2002',
        },
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          'substantiation__vr.name__v': 'SUB-225297',
          'substantiation__vr.substantiation_details__c':
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2003',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Research Institute Letter',
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v':
            'Capture Supplier Literature/Certification',
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Substantiation statement for CLaim 1a',
          'substantiation__vr.name__v': 'SUB-001904',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Dossier Support added',
          'substantiation__vr.name__v': 'SUB-216960',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Survey',
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v': null,
          'substantiation__vr.name__v': 'SUB-000014',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Packaging Reference',
          'substantiation__vr.description__v':
            'Stain Removal Gaia Final_Liquid',
          'substantiation__vr.name__v': 'SUB-000015',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Laboratory test',
          'substantiation__vr.name__v': 'SUB-216957',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
        },
      ],
      support_strategy_rich:
        'The support for this claim will be the two published papers in the Journal of Dentistry.  The first is a clinical study showing relief of sensitivity pain over 4 weeks.  The second paper is a lab test showing formation of HAP mineral on and within',
    },
    {
      claim_la_bid: 'V2Q00000007O007',
      claim_la_id: 'V1900000007U014',
      claim_la_name: 'CLM-087785.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v': 'Dossier Support added',
          'substantiation__vr.name__v': 'SUB-216960',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
        },
        {
          'substantiation__vr.description__v': 'Laboratory test',
          'substantiation__vr.name__v': 'SUB-216957',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
        },
        {
          'substantiation__vr.description__v':
            'Substantiation statement for CLaim 1a',
          'substantiation__vr.name__v': 'SUB-001904',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
        },
      ],
      global_qualifier: null,
      global_statement:
        'Minerals integrate deep into the holes to repair the sensitive area.',
      marketing_channels: ['Pack BOP'],
      marketing_channels_backendname: ['pack_bop__c'],
      qualifier: null,
      statement:
        'Mineral secara mendalam memperbaiki area gigi sensitif tepat pada sumbernya.',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225298',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3003',
        },
      ],
      support_strategy_rich:
        'This claim will be supported by published results of lab tests that show formation of new mineral within dentine tubules.  The results are published in the Journal of Dentistry: In vitro dentine tubule occlusion by a novel toothpaste containing ',
    },
    {
      claim_la_bid: 'V2Q00000007P003',
      claim_la_id: 'V1900000007U016',
      claim_la_name: 'CLM-087787.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v':
            'Substantiation statement for CLaim 1a',
          'substantiation__vr.name__v': 'SUB-001904',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y00000000E011',
        },
        {
          'substantiation__vr.description__v': 'Laboratory test',
          'substantiation__vr.name__v': 'SUB-216957',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
        },
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
        {
          'substantiation__vr.description__v': 'Dossier Support added',
          'substantiation__vr.name__v': 'SUB-216960',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
        },
      ],
      global_qualifier: null,
      global_statement: "Pain doesn't come back",
      marketing_channels: ['Pack FOP'],
      marketing_channels_backendname: ['pack_fop__c'],
      qualifier: 'With regular use, twice daily\n\n\n\n\n',
      statement: 'Cegah ngilu datang kembali.',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          'substantiation__vr.name__v': 'SUB-225299',
          'substantiation__vr.substantiation_details__c':
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
        },
      ],
      support_strategy_rich:
        "This claim will be supported by the published clinical study in the Journal of Dentistry which showed relief of sensitivity pain over 4 weeks brushing.  The disclaimer on 'with regular twice daily use' is important.\n\n",
    },
    {
      claim_la_bid: 'V2Q00000007P004',
      claim_la_id: 'V1900000007U019',
      claim_la_name: 'CLM-087790.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
      ],
      global_qualifier: null,
      global_statement:
        "Pepsodent Sensitivexpert uses patented ActivRemin to form the exact same minerals that teeth are made of.  It completely fills the exposed areas by building a 20 x stronger natural mineral layer.**  Teeth are resealed, restoring the protective power of enamel so pain doesn't come back.*",
      marketing_channels: ['Pack BOP'],
      marketing_channels_backendname: ['pack_bop__c'],
      qualifier:
        'Based on a lab test. 20 times increase in change in surface microhardness over 4 days compared to baseline / no treatment',
      statement:
        'Pepsodent Sensitivexpert mengandung ActivRemin TM yang dipatenkan untuk menutupi area gigi sensitif yang terbuka dengan membentuk mineral yang sama dengan mineral alami gigi. \n20x lapisan mineral lebih kuat***, mencegah ngilu datang kembali*.',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': 'Laboratory Test',
          'substantiation__vr.description__v':
            'REP0154: Increase in dentine microhardness following brushing with CSSP toothpaste, Novamin toothpaste and a fluoride only toothpaste',
          'substantiation__vr.name__v': 'SUB-225300',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2005',
        },
      ],
      support_strategy_rich:
        'This statement will be supported by the results of a dentine remineralisation microhardness study (REP0154) which showed a significant increase in dentine microhardness over 4 days twice a day treatment.  \n\n\n\n\n\n\n\n\n',
    },
    {
      claim_la_bid: 'V2Q00000007O008',
      claim_la_id: 'V1900000007U020',
      claim_la_name: 'CLM-087791.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
      ],
      global_qualifier: null,
      global_statement: 'No. 1 brand+: Recommended by Pepsodent dental expert',
      marketing_channels: ['Pack FOP'],
      marketing_channels_backendname: ['pack_fop__c'],
      qualifier: '\nBased on Nielson market sales data\n\n\n',
      statement: 'No. 1 brand. Direkomendasi Pepsodent dental expert',
      substantiations: [{}],
      support_strategy_rich:
        "Will be supported by data from Nielsen and a letter from Alison Green (Oral Care R&D Director) as the designate 'Pepsodent Dental Expert.'\n\n",
    },
    {
      claim_la_bid: 'V2Q00000007O009',
      claim_la_id: 'V1900000007U021',
      claim_la_name: 'CLM-087792.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
      ],
      global_qualifier: null,
      global_statement:
        'ActivRemin technology releases the same natural mineral as the tooth.',
      marketing_channels: ['Pack BOP'],
      marketing_channels_backendname: ['pack_bop__c'],
      qualifier: null,
      statement:
        'Teknologi ActivRemin TM membentuk mineral alami yang sama dengan lapisan gigi.',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225301',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
        },
      ],
      support_strategy_rich:
        'The claim will be supported by a paper in the Journal of Dentistry which reports how the new mineral formed (HAP) has the same chemical composition and crystal structure as HAP in dentine.  In vitro dentine tubule occlusion by a novel toothpaste ',
    },
    {
      claim_la_bid: 'V2Q00000007P005',
      claim_la_id: 'V1900000007U023',
      claim_la_name: 'CLM-087794.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
      ],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: ['Pack FOP'],
      marketing_channels_backendname: ['pack_fop__c'],
      qualifier: null,
      statement: 'Max Repair',
      substantiations: [{}],
      support_strategy_rich:
        "Variant name.  'Max Repair' because this is the most efficacious technology in the Unilever portfolio \n\n",
    },
    {
      claim_la_bid: 'V2Q00000007O010',
      claim_la_id: 'V1900000007U024',
      claim_la_name: 'CLM-087795.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
      ],
      global_qualifier: null,
      global_statement: '100% proven*',
      marketing_channels: ['Pack FOP'],
      marketing_channels_backendname: ['pack_fop__c'],
      qualifier:
        'Relief of sensitivity is proven in a clinical study\n\n\n\n\n\n\n\n\n',
      statement: '100% terbukti',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225301',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
        },
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Journal of Dentistry paper entitled "A randomised controlled trial investigating efficacy of a novel toothpaste containing calcium silicate and sodium phosphate in dentine hypersensitivity pain reduction compared to a fluoride control toothpaste"',
          'substantiation__vr.name__v': 'SUB-225299',
          'substantiation__vr.substantiation_details__c':
            'Conclusions of the paper: The CSSP toothpaste was more effective than the fluoride control toothpaste at reducing DH pain with benefit persisting 12 h following application.\n\nClinical Significance\nThis novel calcium silicate and sodium phosphate ',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B2004',
        },
      ],
      support_strategy_rich:
        "The support strategy here will be to use the published clinical and in-vitro evidence for the efficacy of the product to relieve sensitivity by occluding dentinal tubules.  We are intending '100% proven' to mean that we have evidence as to the ",
    },
    {
      claim_la_bid: 'V2Q00000007P006',
      claim_la_id: 'V1900000007U027',
      claim_la_name: 'CLM-087798.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v': 'test',
          'substantiation__vr.name__v': 'SUB-378966',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM017',
        },
        {
          'substantiation__vr.description__v': 'test123 description',
          'substantiation__vr.name__v': 'SUB-378965',
          'substantiation__vr.substantiation_details__c': 'test123 details',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM016',
        },
        {
          'substantiation__vr.description__v': 'testing123',
          'substantiation__vr.name__v': 'SUB-378967',
          'substantiation__vr.substantiation_details__c': 'testing123',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000GM018',
        },
      ],
      global_qualifier: null,
      global_statement:
        'Weakened enamel can expose tiny holes in the dentine to cause sensitivity pain.',
      marketing_channels: ['Pack BOP'],
      marketing_channels_backendname: ['pack_bop__c'],
      qualifier: null,
      statement:
        'Melemahnya enamel dapat mengekspos lubang kecil dalam tubulus dentin menyebabkan ngilu pada gigi',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225301',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
        },
      ],
      support_strategy_rich:
        'Factual point well understood and accepted by dentists and dental researchers. No substantiation needed\n\n\n\n\n\n\n\n\n',
    },
    {
      claim_la_bid: 'V2Q0000000CG011',
      claim_la_id: 'V190000000EY014',
      claim_la_name: 'CLM-177366.ID',
      claim_substantiations: [
        {
          'substantiation__vr.description__v':
            'Published Journal of Dentistry paper entitled "In vitro dentine tubule occlusion by a novel toothpaste containing calcium silicate and sodium phosphate"',
          'substantiation__vr.name__v': 'SUB-225301',
          'substantiation__vr.substantiation_details__c':
            'Paper conclusions: The CSSP toothpaste fully occluded dentine tubules and formed the mineral HAP. The dentine deposition on and within dentine tubules was resilient to acid erosive challenges.',
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000B3004',
        },
      ],
      global_qualifier: null,
      global_statement: 'Hibiscus Tonal-Vibrancyâ„¢',
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: 'to add the qualifier for in use statement',
      statement: 'Test',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CR035',
      claim_la_id: 'V190000000FB132',
      claim_la_name: 'CLM-177861.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 4000000',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CR034',
      claim_la_id: 'V190000000FB120',
      claim_la_name: 'CLM-177833.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: [
        'Pack FOP',
        'KV (Key Visual)',
        'Print',
        'Omnichannel',
        'Pack BOP',
        'POS Material',
        'Press Releases',
        'Concept Claims',
        'E-Commerce',
      ],
      marketing_channels_backendname: [
        'pack_fop__c',
        'kv_key_visual__c',
        'email__v',
        'packaging__v',
        'pack_bop__c',
        'pos_material__c',
        'press_releases__c',
        'concept_claim__c',
        'ecommerce__c',
      ],
      qualifier: 'integration check',
      statement: 'test123',
      substantiations: [
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': null,
          'substantiation__vr.description__v': 'hest',
          'substantiation__vr.name__v': 'SUB-216963',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AD001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Dossier Support added',
          'substantiation__vr.name__v': 'SUB-216960',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AB001',
        },
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Claims Test',
          'substantiation__vr.description__v': 'Laboratory test',
          'substantiation__vr.name__v': 'SUB-216957',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y0000000AA001',
        },
      ],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CS051',
      claim_la_id: 'V190000000FC113',
      claim_la_name: 'CLM-177856.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 123',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CS052',
      claim_la_id: 'V190000000FC121',
      claim_la_name: 'CLM-177868.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 12313123123',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU013',
      claim_la_id: 'V190000000FE011',
      claim_la_name: 'CLM-177883.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: 'test',
      statement: 'demo_12',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU016',
      claim_la_id: 'V190000000FF005',
      claim_la_name: 'CLM-177886.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: 'test',
      statement: 'demo_13',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV019',
      claim_la_id: 'V190000000FF006',
      claim_la_name: 'CLM-177889.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: ['Pack BOP'],
      marketing_channels_backendname: ['pack_bop__c'],
      qualifier: 'test_21',
      statement: 'demo_21',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV021',
      claim_la_id: 'V190000000FE016',
      claim_la_name: 'CLM-177890.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: ['Omnichannel'],
      marketing_channels_backendname: ['packaging__v'],
      qualifier: 'test_20',
      statement: 'demo_20',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV020',
      claim_la_id: 'V190000000FF007',
      claim_la_name: 'CLM-177891.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: ['E-Commerce'],
      marketing_channels_backendname: ['ecommerce__c'],
      qualifier: 'test_23',
      statement: 'demo_23',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU019',
      claim_la_id: 'V190000000FE018',
      claim_la_name: 'CLM-177895.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_13',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV023',
      claim_la_id: 'V190000000FF010',
      claim_la_name: 'CLM-177896.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_12',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU024',
      claim_la_id: 'V190000000FE023',
      claim_la_name: 'CLM-177905.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'statement 500000000000000000',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV033',
      claim_la_id: 'V190000000FE032',
      claim_la_name: 'CLM-177924.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: ['Press Releases'],
      marketing_channels_backendname: ['press_releases__c'],
      qualifier: 'data',
      statement: 'Max Repair two',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV035',
      claim_la_id: 'V190000000FE033',
      claim_la_name: 'CLM-177928.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test123123123123123123',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV056',
      claim_la_id: 'V190000000FB056',
      claim_la_name: 'CLM-177818.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'Test 1',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU048',
      claim_la_id: 'V190000000FF063',
      claim_la_name: 'CLM-178003.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: 'Tst',
      statement: 'test2',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU051',
      claim_la_id: 'V190000000FE073',
      claim_la_name: 'CLM-178004.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement:
        'Try new all fresh & sensitive™  With a clean  fresh hypoallergenic scent  its gentle on skin  but tough on stains.',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV061',
      claim_la_id: 'V190000000FF065',
      claim_la_name: 'CLM-178007.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'Now you can have it all',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV001',
      claim_la_id: 'V190000000FE002',
      claim_la_name: 'CLM-177870.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV013',
      claim_la_id: 'V190000000FE005',
      claim_la_name: 'CLM-177873.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo_01',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU014',
      claim_la_id: 'V190000000FE012',
      claim_la_name: 'CLM-177884.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'demo_11',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV022',
      claim_la_id: 'V190000000FE019',
      claim_la_name: 'CLM-177897.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_14',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU022',
      claim_la_id: 'V190000000FF014',
      claim_la_name: 'CLM-177902.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV026',
      claim_la_id: 'V190000000FF015',
      claim_la_name: 'CLM-177906.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test234',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV036',
      claim_la_id: 'V190000000FE034',
      claim_la_name: 'CLM-177930.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test_23',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV039',
      claim_la_id: 'V190000000FF032',
      claim_la_name: 'CLM-177936.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'test demo',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CU040',
      claim_la_id: 'V190000000FE053',
      claim_la_name: 'CLM-177964.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'testqwe',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV062',
      claim_la_id: 'V190000000FF064',
      claim_la_name: 'CLM-178008.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'stainlifters',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV063',
      claim_la_id: 'V190000000FF066',
      claim_la_name: 'CLM-178006.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'WA fresh & sensitive dyc-free',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CV060',
      claim_la_id: 'V190000000FE074',
      claim_la_name: 'CLM-178005.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'Clean  Fresh Scent',
      substantiations: [{}],
      support_strategy_rich: null,
    },
    {
      claim_la_bid: 'V2Q0000000CX001',
      claim_la_id: 'V190000000FH004',
      claim_la_name: 'CLM-178022.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier:
        'Laborartowertrry test. Applies only to toothbrush bristles and not inside the mouth. Silver phosphate treated bristle',
      statement: 'Demo Testing for check',
      substantiations: [
        {
          'country__cr.name__v': null,
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v': null,
          'substantiation__vr.name__v': 'SUB-000014',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007003',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Packaging Reference',
          'substantiation__vr.description__v':
            'Stain Removal Gaia Final_Liquid',
          'substantiation__vr.name__v': 'SUB-000015',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007004',
        },
      ],
      support_strategy_rich: 'only sup sub frsdfom dev',
    },
    {
      claim_la_bid: 'V2Q0000000CX002',
      claim_la_id: 'V190000000FG016',
      claim_la_name: 'CLM-178030.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: ['Concept Claims', 'Pack BOP', 'KV (Key Visual)'],
      marketing_channels_backendname: [
        'concept_claim__c',
        'pack_bop__c',
        'kv_key_visual__c',
      ],
      qualifier: 'Qualifier Example from Claim</p>',
      statement: 'Inheriting from claim DEMO',
      substantiations: [
        {
          'country__cr.name__v': 'Global',
          'related_reference__vr.subtype__v': 'Formulation Reference',
          'substantiation__vr.description__v': 'SLI spec sheet',
          'substantiation__vr.name__v': 'SUB-000044',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007033',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Appraisal Test',
          'substantiation__vr.description__v':
            'Suporte Claim Unbeatable whiteness',
          'substantiation__vr.name__v': 'SUB-000043',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007032',
        },
        {
          'country__cr.name__v': 'Brazil',
          'related_reference__vr.subtype__v': 'Other',
          'substantiation__vr.description__v':
            'Suporte Claim Cuida do meio ambiente',
          'substantiation__vr.name__v': 'SUB-000042',
          'substantiation__vr.substantiation_details__c': null,
          substantiation_link:
            'https://sb-unilever-claims-qa.veevavault.com/ui/#t/0TB000000000C05/V3Y/V3Y000000007031',
        },
      ],
      support_strategy_rich: 'Adding support strategy from SPARCI',
    },
    {
      claim_la_bid: 'V2Q0000000CW001',
      claim_la_id: 'V190000000FG001',
      claim_la_name: 'CLM-178009.ID',
      claim_substantiations: [],
      global_qualifier: null,
      global_statement: null,
      marketing_channels: null,
      marketing_channels_backendname: null,
      qualifier: null,
      statement: 'testing123',
      substantiations: [{}],
      support_strategy_rich: null,
    },
  ];

  getSupportStrategyTableDetails(data): Observable<any> {
    const url = Const.connectionUrl + '/api/get-claim-supsub';
    return this.http.post(url, data);
    // return of(this.mockdata_color);
    // return of(this.Json_Mock_SavedSession);
  }
  removeSubstantiationId(data): Observable<any> {
    const url = Const.connectionUrl + '/api/remove_substantiations';
    return this.http.post(url, data);
    // return of(MOCK_JSON);
  }

  removeSubstantiation(data): Observable<any> {
    const url =
      Const.connectionUrl + '/api/remove_substantiation_from_claim_la';
    return this.http.post(url, data);
    // return of(MOCK_JSON);
  }

  private formattedSource = new BehaviorSubject<boolean>(false);
  isFormatted$ = this.formattedSource.asObservable();

  setFormatted(value: boolean) {
    this.formattedSource.next(value);
  }

  private editorTrigger = new Subject<number>();
  editorTrigger$ = this.editorTrigger.asObservable();

  triggerEditor(index: number) {
    this.editorTrigger.next(index);
  }

  saveFromSupportSubstantiation(data): Observable<any> {
    const url = Const.connectionUrl + '/api/save_from_support_substantiation';
    return this.http.post(url, data);
    // return of(MOCK_JSON);
  }

  marketing_mock = {
    picklistValues: [
      {
        label: 'Concept Claims',
        name: 'concept_claim__c',
      },
      {
        label: 'E-Commerce',
        name: 'ecommerce__c',
      },
      {
        label: 'KV (Key Visual)',
        name: 'kv_key_visual__c',
      },
      {
        label: 'Omnichannel',
        name: 'packaging__v',
      },
      {
        label: 'Pack BOP',
        name: 'pack_bop__c',
      },
      {
        label: 'Pack FOP',
        name: 'pack_fop__c',
      },
      {
        label: 'POS Material',
        name: 'pos_material__c',
      },
      {
        label: 'Press Releases',
        name: 'press_releases__c',
      },
      {
        label: 'Print',
        name: 'email__v',
      },
      {
        label: 'Social Media',
        name: 'social_media__v',
      },
      {
        label: 'SOP',
        name: 'sop__c',
      },
      {
        label: 'TOP',
        name: 'top__c',
      },
      {
        label: 'TVC (Television Commercial)',
        name: 'tvc_television_commercial__v',
      },
      {
        label: 'Website',
        name: 'website__v',
      },
      {
        label: 'General',
        name: 'general__c',
      },
    ],
    responseMessage: 'Success',
    responseStatus: 'SUCCESS',
  };
  getMarketingChannelsubstantiation(data): Observable<any> {
    const url = Const.connectionUrl + '/api/get_marketing_channel_with_value';
    return this.http.post(url, data);
    return of(this.marketing_mock);
  }
}
